module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2YZ51X/tc-custom/9798891555228.jpg?1725723409084",
      "alt": "This image is the cover for the book Unraveling Taboo: Love's Unexpected Pathways"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unraveling Taboo: Love's Unexpected Pathways\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In a world where sexuality, love, greed, and money take on new meanings, and death lurks around every corner, a captivating story unfolds. Father, a sophisticated and wealthy 60-year-old man, and his 34-year-old son both find themselves enamored with a stunning 27-year-old single woman. Initially, she becomes the lover of the father, a known adventurer with a penchant for beautiful, young women. However, when she meets his son, she falls deeply in love and marries him, perhaps driven by financial motives.")]), _c('p', [_vm._v("The tycoon, her ex-lover and now father-in-law, cannot and will not relinquish his love for her. He insists on continuing their intimate relationship, even resorting to pressure and ultimatums when she objects. Despite the husband’s suspicions, it is the wife herself who reveals the shocking truth: she has been regularly sleeping with his father, both before and after their marriage.")]), _c('p', [_vm._v("A war erupts between the three, as life teaches us to smile through the tears. Who do you think will be the first to die? Or is the human being simply a poor customer of life? Life on earth is a journey filled with people we encounter in all seasons. Some accompany us, while others remain behind. Those who stay with us will witness our happiness, smiles, sadness, and ultimately, our death. In a world that is absurd, full of wonders, and where death is ever-present, life is riddled with disappointment. We always need that breath of air to outlet our emotions, to breathe heavily and calm ourselves down. ")]), _c('p', [_c('em', [_vm._v("‘There is no such thing as one hundred percent security in this life; there are always unforeseen events. Living is an art, and dying is an art as well.’")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr. Anthony Mathews\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_vm._v("Dr. Anthony Mathews:")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_vm._v("Married.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_vm._v("Studied in Germany, Spain, Russia, and England: Diplomacy, International Relations, International Rights, Foreign Affairs, and Business Administration.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_vm._v("Doctorate in International Relations and Business Administration.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_vm._v("He always writes by hand. He writes because he loves literature, without commercial interest. He writes as he wants and without any pressure on sales, marketing, or recognition.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_vm._v("As a kid, he lived in different countries, so he is a cosmopolitan with a deep respect for diverse cultures, peoples, and nationalities, and he speaks many languages.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_vm._v("He is confident that the reader will find a phrase to reflect on, think about, or discuss with someone or with oneself.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0